module.exports = __webpack_public_path__ + "img/asian-chicken-broccoli-2.90e018a4.jpg";